"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.createGameObject = void 0;
var phaser_1 = __importDefault(require("phaser"));
var GameObjects = __importStar(require("../components/GameObjects"));
var element_1 = require("../element");
var props_1 = require("./props");
var ref_1 = require("./ref");
var gameObjects = Object.keys(GameObjects).map(function (key) { return GameObjects[key]; });
/**
 * Creates Phaser game object and adds it to the container.
 *
 * @param element - Element that you want to create.
 * @param scene - Phaser scene.
 * @returns - Phaser game object.
 */
function createGameObject(element, scene) {
    if (!(0, element_1.isValidElement)(element)) {
        return;
    }
    var _a = element.props, children = _a.children, 
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    key = _a.key, ref = _a.ref, style = _a.style, text = _a.text, props = __rest(_a, ["children", "key", "ref", "style", "text"]);
    var gameObject;
    switch (true) {
        case element.type === phaser_1.default.GameObjects.Text:
            gameObject = new element.type(scene, props.x, props.y, text, style);
            break;
        case element.type === phaser_1.default.GameObjects.Rectangle:
            gameObject = new element.type(scene, props.x, props.y, props.width, props.height, props.fillColor, props.fillAlpha);
            break;
        case gameObjects.indexOf(element.type) > -1:
            gameObject = new element.type(scene);
            break;
        default:
            return createGameObject(new element.type(element.props), scene);
    }
    (0, props_1.setProps)(gameObject, props, scene);
    (0, ref_1.attachRef)(gameObject, ref);
    if (Array.isArray(children)) {
        children.forEach(function (element) {
            var childGameObject = createGameObject(element, scene);
            /* istanbul ignore if */
            if (!childGameObject) {
                return;
            }
            if (gameObject instanceof phaser_1.default.GameObjects.Container) {
                gameObject.add(childGameObject);
            }
            else {
                scene.add.existing(childGameObject);
            }
        });
    }
    return gameObject;
}
exports.createGameObject = createGameObject;
//# sourceMappingURL=gameobject.js.map